import { useEffect } from "react";
import { useLazyGetCustomerActiveLoanDetailsQuery } from "../../../service/customer-service";
import styles from "./AdminCustomerDetailsPage.module.scss";
import { toast } from "react-toastify";

export interface ActiveLoanDetailsProps {
	customerId: string;
}

const ActiveLoanDetails: React.FC<ActiveLoanDetailsProps> = ({ customerId }) => {
	const [getActiveLoanDetails, { isLoading, data }] = useLazyGetCustomerActiveLoanDetailsQuery();
	useEffect(() => {
		getActiveLoanDetails(customerId)
			.unwrap()
			.then()
			.catch(err => toast.error(err?.data?.title as string));
	}, []);
	return (
		<div className={styles.activeLoanContainer}>
			<div className={styles.row}>
				<div className={styles.column}>Initial Deposit</div>
				<div className={styles.column}>₦ {data?.initialDeposit?.toLocaleString()}</div>
			</div>
			<div className={styles.row}>
				<div className={styles.column}>Loan (Principal)</div>
				<div className={styles.column}>₦ {data?.loanPrincipal?.toLocaleString()}</div>
			</div>
			<div className={styles.row}>
				<div className={styles.column}>Loan interest</div>
				<div className={styles.column}>
					₦ {data?.loanInterest?.toLocaleString()} <span>{data?.loanInterest?.toLocaleString()}%</span>
				</div>
			</div>
			<div className={styles.row}>
				<div className={styles.column}>Amount Paid Back</div>
				<div className={styles.column}>₦ {data?.amountPaidBack?.toLocaleString()}</div>
			</div>
			<div className={styles.row}>
				<div className={styles.column}>Amount Outstanding</div>
				<div className={styles.column}>₦ {data?.outstandingAmount?.toLocaleString()}</div>
			</div>
			<div className={styles.row}>
				<div className={styles.column}>Loan Duration</div>
				<div className={styles.column}>{data?.durationInMonths} Months</div>
			</div>
		</div>
	);
};
export default ActiveLoanDetails;
